import { useTheme } from '@mui/material';

export const ClosingSoonIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
        >
            <path
                d="M38 24C38 20.287 36.525 16.726 33.8995 14.1005C31.274 11.475 27.713 10 24 10C20.287 10 16.726 11.475 14.1005 14.1005C11.475 16.726 10 20.287 10 24C10 27.713 11.475 31.274 14.1005 33.8995C16.726 36.525 20.287 38 24 38C27.713 38 31.274 36.525 33.8995 33.8995C36.525 31.274 38 27.713 38 24ZM8 24C8 19.7565 9.68571 15.6869 12.6863 12.6863C15.6869 9.68571 19.7565 8 24 8C28.2435 8 32.3131 9.68571 35.3137 12.6863C38.3143 15.6869 40 19.7565 40 24C40 28.2435 38.3143 32.3131 35.3137 35.3137C32.3131 38.3143 28.2435 40 24 40C19.7565 40 15.6869 38.3143 12.6863 35.3137C9.68571 32.3131 8 28.2435 8 24ZM25 15V23.7L28.8312 29.45C29.1375 29.9125 29.0125 30.5312 28.5562 30.8375C28.1 31.1437 27.475 31.0187 27.1688 30.5625L23.1687 24.5625C23.0562 24.4 23 24.2063 23 24.0063V15.0062C23 14.4562 23.45 14.0062 24 14.0062C24.55 14.0062 25 14.4562 25 15.0062V15Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
